import React from 'react';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Wrapper, WrapperProps } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { useExplanations } from './useExplanations';
import { ExplanationsLoading } from './Explanations.loading';

interface ExplanationsProps extends WrapperProps {
  selectedTab: string;
  goalId?: string;
}

export const Explanations = ({ selectedTab, goalId, ...props }: ExplanationsProps) => {
  const { isLoading, data } = useExplanations({ selectedTab, goalId });

  if (isLoading) {
    return <ExplanationsLoading />;
  }

  if (!data) {
    return null;
  }

  const { title, message } = data;

  return (
    <Wrapper {...props}>
      {title && <Text fontWeight={600}>{title}</Text>}

      {message && (
        <Text fontSize="small" fontWeight={400} color="neutral.500">
          {message}
        </Text>
      )}
    </Wrapper>
  );
};
